import { NgModule, APP_INITIALIZER, ErrorHandler, isDevMode } from '@angular/core';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { ThemeService } from 'src/utils/theme.service';
import { get1, isMaintenanceResponse } from 'src/utils/api';
import { APP_HD_URL1 } from 'src/utils/urls';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ChunkLoadErrorHandler } from './chunk-load-error-handler';
import { metaReducers, reducers } from './store';
import { AdminComponent } from './theme/layout/admin/admin.component';
import { NavigationItem } from './theme/layout/admin/navigation/navigation';
import { NavBarComponent } from './theme/layout/admin/nav-bar/nav-bar.component';
import { NavLeftComponent } from './theme/layout/admin/nav-bar/nav-left/nav-left.component';
import { NavRightComponent } from './theme/layout/admin/nav-bar/nav-right/nav-right.component';
import { NavigationComponent } from './theme/layout/admin/navigation/navigation.component';
import { NavLogoComponent } from './theme/layout/admin/nav-bar/nav-logo/nav-logo.component';
import { NavContentComponent } from './theme/layout/admin/navigation/nav-content/nav-content.component';
import { NavGroupComponent } from './theme/layout/admin/navigation/nav-content/nav-group/nav-group.component';
import { NavCollapseComponent } from './theme/layout/admin/navigation/nav-content/nav-collapse/nav-collapse.component';
import { NavItemComponent } from './theme/layout/admin/navigation/nav-content/nav-item/nav-item.component';
import { SharedModule } from './theme/shared/shared.module';
import { ConfigurationComponent } from './theme/layout/admin/configuration/configuration.component';
import { GuestComponent } from './theme/layout/guest/guest.component';
import { DemoNgZorroAntdModule } from './ng-zorro-antd.module';
import { NzConfig, provideNzConfig } from 'ng-zorro-antd/core/config';
import { provideNzDateFnsAdapter } from 'ng-zorro-antd/core/time';
import { HttpClientModule } from '@angular/common/http';
// import { PrivacyPolicyModalComponent } from './demo/pages/authentication/login/modal/policy.component';
// import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { ChangePasswordModalComponent } from './component/modal/change-password.component';
import { TFAModalComponent } from './component/modal/tfa-modal.component';
import { PageBreadcrumbComponent } from './component/page-breadcrumb/page-breadcrumb.component';
import { FilterDrawerComponent } from './component/filter-drawer/filter-drawer.component';
// import { TFAAuthComponent } from './demo/pages/authentication/login/component/tfa-screen/tfa-auth.component';
import { NzIconModule } from 'ng-zorro-antd/icon';
import {
  ArrowLeftOutline,
  ArrowRightOutline,
  InfoCircleOutline,
  EyeOutline,
  CheckOutline,
  HistoryOutline,
  IssuesCloseOutline,
  MailOutline,
  BugOutline,
  LockOutline,
  UnlockOutline,
  FormOutline,
  FilterOutline,
  RollbackOutline,
  UserSwitchOutline,
  LeftCircleOutline,
  RightCircleOutline,
  FileSearchOutline,
  DownloadOutline,
  UnorderedListOutline,
  OrderedListOutline,
  FileExclamationOutline,
  DatabaseOutline,
  FileExcelOutline,
  HomeOutline,
  AreaChartOutline,
  SettingOutline,
  InboxOutline,
  PlusOutline,
  GlobalOutline,
  // web-referral form icons
  UserOutline,
  IdcardOutline,
  PhoneOutline,
  ContactsOutline,
  TeamOutline,
  MedicineBoxOutline,
  SafetyOutline,
  SafetyCertificateOutline,
  CalendarOutline,
  ProfileOutline,
  BankOutline,
  AuditOutline,
  InsuranceOutline,
  CreditCardOutline,
  DollarOutline,
  DollarCircleOutline,
  ExperimentOutline,
  FileTextOutline,
  HeartOutline,
  WarningOutline,
  ThunderboltOutline,
  FlagOutline,
  FileAddOutline,
  CheckCircleOutline,
  CheckCircleFill,
  CloudUploadOutline,
  FolderOpenOutline,
  PlusCircleOutline,
  FileOutline,
  DeleteOutline,
  TagOutline,
  FileProtectOutline,
  PaperClipOutline,
  ExclamationCircleOutline,
  CheckSquareOutline,
  FilePdfOutline,
  FileUnknownOutline,
  SaveOutline,
  SendOutline,
  LeftOutline,
  RightOutline,
  LeftSquareOutline,
  RightSquareOutline,
  DoubleLeftOutline,
  DoubleRightOutline,
  ZoomInOutline,
  ZoomOutOutline,
  // web-referral Referral Reasons subsection icons
  FrownOutline,
  BulbOutline,
  CoffeeOutline,
  SwapOutline,
  // ── Nav menu icons ──────────────────────────────────────
  DashboardOutline,
  FileDoneOutline,
  AppstoreOutline,
  SolutionOutline,
  PauseCircleOutline,
  UsergroupAddOutline,
  ToolOutline,
  BuildOutline,
  EnvironmentOutline,
  // ── Referral queue / tile icons ─────────────────────────
  SyncOutline,
  AlertOutline,
  ReloadOutline,
  ClockCircleOutline,
  SearchOutline,
  CloseCircleOutline,
  BellOutline,
  MinusCircleOutline,
  LinkOutline,
  CloseOutline,
  CompressOutline,
  UndoOutline,
  RedoOutline,
  FullscreenOutline,
  FullscreenExitOutline,
  RotateLeftOutline,
  RotateRightOutline,
  // ── Document dashboard KPI tile icons ───────────────────
  PercentageOutline,
  BarChartOutline,
  CopyOutline,
  ShareAltOutline,
  // ── Page Entities Admin / Page Layout / Tenant Config icons ─────────────
  EditOutline,
  TableOutline,
  HolderOutline,
  AlignLeftOutline,
  EyeInvisibleOutline,
  // ── Tenant Config field/tab type icons ──────────────────────────────────
  BgColorsOutline,
  NumberOutline,
  FontSizeOutline,
  KeyOutline,
  ApiOutline,
  ScanOutline,
  BranchesOutline,
  CloudServerOutline,
  ImportOutline,
  RobotOutline,
  SortAscendingOutline,
  SortDescendingOutline,
  // ── Queue / Packet Buckets / Admin nav submenu icons ─────
  ContainerOutline,
  AppstoreAddOutline,
  QuestionCircleOutline,
  PicRightOutline,
  ExceptionOutline,
  RestOutline,
  CloudDownloadOutline,
  MenuFoldOutline,
  LaptopOutline
} from '@ant-design/icons-angular/icons';
// import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { CommonModule } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
// import { NzFormModule } from 'ng-zorro-antd/form';
const ngZorroConfig: NzConfig = {
  message: { nzTop: 90 },
  notification: { nzTop: 240 }
};
@NgModule({
  declarations: [
    AppComponent,
    AdminComponent,
    NavBarComponent,
    NavLeftComponent,
    NavRightComponent,
    NavigationComponent,
    NavLogoComponent,
    NavContentComponent,
    NavGroupComponent,
    NavItemComponent,
    NavCollapseComponent,
    ConfigurationComponent,
    GuestComponent,
    ChangePasswordModalComponent,
    TFAModalComponent
  ],

  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    DemoNgZorroAntdModule,
    HttpClientModule,
    PageBreadcrumbComponent,
    FilterDrawerComponent,
    // PrivacyPolicyModalComponent,
    // PowerBIEmbedModule,
    // TFAAuthComponent,
    NzIconModule.forRoot([
      ArrowLeftOutline,
      ArrowRightOutline,
      InfoCircleOutline,
      EyeOutline,
      CheckOutline,
      HistoryOutline,
      IssuesCloseOutline,
      MailOutline,
      BugOutline,
      LockOutline,
      UnlockOutline,
      FormOutline,
      FilterOutline,
      RollbackOutline,
      UserSwitchOutline,
      LeftCircleOutline,
      RightCircleOutline,
      FileSearchOutline,
      LockOutline,
      UnlockOutline,
      DownloadOutline,
      UnorderedListOutline,
      OrderedListOutline,
      FileExclamationOutline,
      DatabaseOutline,
      FileExcelOutline,
      HomeOutline,
      AreaChartOutline,
      SettingOutline,
      InboxOutline,
      PlusOutline,
      GlobalOutline,
      // web-referral form icons
      UserOutline,
      IdcardOutline,
      PhoneOutline,
      ContactsOutline,
      TeamOutline,
      MedicineBoxOutline,
      SafetyOutline,
      SafetyCertificateOutline,
      CalendarOutline,
      ProfileOutline,
      BankOutline,
      AuditOutline,
      InsuranceOutline,
      CreditCardOutline,
      DollarOutline,
      DollarCircleOutline,
      ExperimentOutline,
      FileTextOutline,
      HeartOutline,
      WarningOutline,
      ThunderboltOutline,
      FlagOutline,
      FileAddOutline,
      CheckCircleOutline,
      CheckCircleFill,
      CloudUploadOutline,
      FolderOpenOutline,
      PlusCircleOutline,
      FileOutline,
      DeleteOutline,
      TagOutline,
      FileProtectOutline,
      PaperClipOutline,
      ExclamationCircleOutline,
      CheckSquareOutline,
      FilePdfOutline,
      FileUnknownOutline,
      SaveOutline,
      SendOutline,
      LeftOutline,
      RightOutline,
      LeftSquareOutline,
      RightSquareOutline,
      DoubleLeftOutline,
      DoubleRightOutline,
      ZoomInOutline,
      ZoomOutOutline,
      // web-referral Referral Reasons subsection icons
      FrownOutline,
      BulbOutline,
      CoffeeOutline,
      SwapOutline,
      // ── Nav menu icons ────────────────────────────────────
      DashboardOutline,
      FileDoneOutline,
      AppstoreOutline,
      SolutionOutline,
      PauseCircleOutline,
      UsergroupAddOutline,
      ToolOutline,
      BuildOutline,
      EnvironmentOutline,
      // ── Referral queue / tile icons ───────────────────────
      SyncOutline,
      AlertOutline,
      ReloadOutline,
      ClockCircleOutline,
      SearchOutline,
      CloseCircleOutline,
      BellOutline,
      MinusCircleOutline,
      LinkOutline,
      CloseOutline,
      CompressOutline,
      UndoOutline,
      RedoOutline,
      FullscreenOutline,
      FullscreenExitOutline,
      RotateLeftOutline,
      RotateRightOutline,
      // ── Document dashboard KPI tile icons ─────────────────
      PercentageOutline,
      BarChartOutline,
      CopyOutline,
      ShareAltOutline,
      // ── Queue / Packet Buckets / Admin nav submenu icons ────
      ContainerOutline,
      AppstoreAddOutline,
      QuestionCircleOutline,
      PicRightOutline,
      ExceptionOutline,
      RestOutline,
      CloudDownloadOutline,
      MenuFoldOutline,
      LaptopOutline,
      // ── Page Entities Admin / Page Layout / Tenant Config icons ─────────
      EditOutline,
      TableOutline,
      HolderOutline,
      AlignLeftOutline,
      EyeInvisibleOutline,
      BgColorsOutline,
      NumberOutline,
      FontSizeOutline,
      KeyOutline,
      ApiOutline,
      ScanOutline,
      BranchesOutline,
      CloudServerOutline,
      ImportOutline,
      RobotOutline,
      SortAscendingOutline,
      SortDescendingOutline
    ]),
    // NzTabsModule,
    CommonModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      // Enabled on every real deployment (dev/tst/uat/prod), not just when environment.production
      // is true — UAT deliberately sets production:false for app behavior, but the service worker
      // still needs to run there so update-detection works on that deployment too.
      enabled: !['localhost', '127.0.0.1'].includes(window.location.hostname),
      registrationStrategy: 'registerWhenStable:30000'
    })
    // NzFormModule
  ],
  providers: [
    NavigationItem,
    provideNzConfig(ngZorroConfig),
    provideNzDateFnsAdapter(),
    // Runtime checks only run in dev builds; the serializability ones keep Dates and other class
    // instances out of the store, so what's in it is exactly what the sessionStorage mirror saves.
    provideStore(reducers, {
      metaReducers,
      runtimeChecks: { strictStateSerializability: true, strictActionSerializability: true }
    }),
    // Redux DevTools in dev builds only — the store holds users' filters, patient names among them.
    isDevMode() ? provideStoreDevtools({ maxAge: 25 }) : [],
    { provide: ErrorHandler, useClass: ChunkLoadErrorHandler },
    {
      provide: APP_INITIALIZER,
      useFactory: (themeService: ThemeService) => async () => {
        // Ask the API up front whether it's in maintenance, so SYSTEM_MAINTENANCE_MODE shows the
        // maintenance page instead of the main page on load (also for logged-out users). Capped
        // at 3s so a slow API never holds up startup; any other failure just carries on.
        if (window.location.pathname !== '/maintenance') {
          const status: any = await Promise.race([
            get1(APP_HD_URL1 + 'api/System/status'),
            new Promise((resolve) => setTimeout(() => resolve(null), 3000))
          ]);
          if (isMaintenanceResponse(status)) {
            // The axios interceptor is already navigating to /maintenance — hold bootstrap so
            // the main page never flashes before the redirect lands.
            return new Promise<void>(() => {});
          }
        }

        const isLoggedIn = !!localStorage.getItem('token');
        const tenantId = localStorage.getItem('tenantId');

        if (isLoggedIn && tenantId) {
          if (!localStorage.getItem('tenant_config')) {
            try {
              const res: any = await get1(APP_HD_URL1 + 'api/Settings/tenant/' + tenantId);
              if (res?.status === 200 && res?.data?.data) {
                const d = res.data.data;
                localStorage.setItem('tenant_config', JSON.stringify(d));
                localStorage.setItem('tenantName', d.tenant_name ?? d.tenantName ?? '');
              }
            } catch {}
          }
          themeService.applyFromStorage();
        } else {
          themeService.reset();
        }
      },
      deps: [ThemeService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
